// extracted by mini-css-extract-plugin
export default {"form":"CardsActivate_form__26HkD","input":"CardsActivate_input__-sGlg"};